import Vue from "vue";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    currentProperty: {
      propertyId: "",
      propertyType: "",
      ownershipType: "",
      clientType: "",
      unitNo: "",
      streetAddress: "",
      city: "",
      subdivision: "",
      state: "New Jersey",
      zipcode: "",
      county: "",
      contactInfoId: "",
      deedNames: [""],
      registrationFiled: "",
      registrationFiles: [],
      status: "type",
    },
    properties: [],
    steps: {
      type: "",
      address: "",
      registration: "",
      owner: "",
      associationToOwner: "",
      contact: "",
    },
    contactInfos: [],
    loading: true,
  },
  mutations: {
    set_current_property(state, property) {
      console.log("set_current_property was called. property:", property) 
      Vue.set(state, "currentProperty", property);
    },
    set_steps(state, steps) {
      Vue.set(state, "steps", steps);
    },
    update_current_property(state, subProperty) {
      console.log("update_current_property was called. property:", subProperty) 
      const currentPropertyInstance = Object.assign({}, state.currentProperty);

      for (const key in subProperty) {
        currentPropertyInstance[key] = subProperty[key];
      }

      Vue.set(state, "currentProperty", currentPropertyInstance);
    },
    set_properties(state, properties) {
      Vue.set(state, "properties", properties);
    },
    set_loading(state, flag) {
      Vue.set(state, "loading", flag);
    },
    init_property(state) {
      Vue.set(state, "currentProperty", {
        propertyId: "",
        propertyType: "",
        ownershipType: "",
        clientType: "",
        unitNo: "",
        streetAddress: "",
        city: "",
        subdivision: "",
        state: "New Jersey",
        zipcode: "",
        county: "",
        contactInfoId: "",
        deedNames: [""],
        registrationFiled: "",
        registrationFiles: [],
        status: "type",
      });
    },
    set_contactInfos(state, contactInfos) {
      Vue.set(state, "contactInfos", contactInfos);
    }
  },
  actions: {
    // eslint-disable-next-line
    loadProperties({ commit, getters, rootState, rootGetters }) {
      if (!rootGetters.isAuthenticated) {
        const localProperty = localStorage.getItem("property")
        commit("set_current_property", JSON.parse(localProperty));
        return;
      }

      commit("set_loading", true);

      return axios
        .get(`${process.env.VUE_APP_URL}/properties`, {
          params: {
            clientId: rootGetters.client.id,
          },
        })
        .then((r) => r.data)
        .then((data) => {
          commit("set_properties", data);

          // if(!getters.currentProperty.propertyId){
          //   const { propertyId } = currentCase.property
          //   const currentProperty = propertyId && data.find(property => property.propertyId === propertyId)
          //   console.log(`currentProperty`, currentProperty)
          //   currentProperty && commit("set_current_property", currentProperty)
          // }

          commit("set_loading", false);

          return Promise.resolve(data);
        });
    },
    async loadProperty({ commit, rootGetters }, propertyId) {
      if (!rootGetters.isAuthenticated) {
        const localProperty = localStorage.getItem("property")
        commit("set_current_property", JSON.parse(localProperty));
        return;
      }
      const propertyRes = await axios.get(`${process.env.VUE_APP_URL}/property/${propertyId}`);
      const property = propertyRes.data;
      await commit("set_current_property", property);
    },
    saveProperty({ commit, getters, rootGetters }, { propertyData, steps }) {
      const updatedProperty =  { ...getters.currentProperty, ...propertyData };
      commit("set_steps", steps);

      if (rootGetters.isAuthenticated) {
        return axios.post(`${process.env.VUE_APP_URL}/properties/save`, {
          property: updatedProperty,
          clientId: rootGetters.client.id,
        })
          .then((r) => r.data)
          .then((data) => {
            commit("update_current_property", { ...data });

            return Promise.resolve(data)
          });
      } else {
        // save to localStorage for when user creates account
        localStorage.setItem("property", JSON.stringify(updatedProperty));
        commit("update_current_property", updatedProperty);
      }
    },
    loadContactInfos({ commit, rootGetters }) {
      commit("set_loading", true);
      return axios
        .get(`${process.env.VUE_APP_URL}/api/contactInfo/` + rootGetters.client.id)
        .then((r) => r.data)
        .then((data) => {          
          commit("set_contactInfos", data);
          commit("set_loading", false);
          return Promise.resolve(data);
        });
    },
    getRegistrationDocs({ commit, rootGetters }, { propertyId } ) {
      if (!rootGetters.isAuthenticated) {
        const registrationFileData = localStorage.getItem('registration_file_data');

        if (registrationFileData) {
          commit("update_current_property", { registrationFiles: [JSON.parse(registrationFileData)] });
        }

        return;
      }

      console.log('getRegistrationDocs :>> propertyId', propertyId);
      return axios
        .get(`${process.env.VUE_APP_URL}/registration/?propertyId=${propertyId}`)
        .then((res) => {          
          commit("update_current_property", { registrationFiles: res.data });
        });
    },
    
  },
  getters: {
    currentPropertyId: (state) => state.currentProperty.propertyId,
    currentProperty: (state) => state.currentProperty,
    propertySteps: (state) => state.steps,
    properties: (state) => state.properties,
    contactInfos: (state) => state.contactInfos,
    loading: (state) => state.loading,
  },
};
